import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SwalService } from '../service/swal.service';
import { SKIP_LOADING } from './http-context';

/**
 * Mostra il loader globale (Swal) per la durata della richiesta e lo chiude
 * quando questa termina (successo o errore), grazie a `finalize`.
 *
 * Centralizza ciò che prima era duplicato in ogni metodo di ConnectionService
 * (this.loading() all'inizio, this.swal.close() in ogni callback).
 *
 * Le richieste marcate con SKIP_LOADING (ex prefisso '@', es. polling notifiche)
 * passano senza loader.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING)) {
    return next(req);
  }

  const swal = inject(SwalService);
  swal.loading('');

  return next(req).pipe(finalize(() => swal.close()));
};
